import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import { InputGroup, FormControl, Button, Image } from 'react-bootstrap';
import { s360ConfigService } from "../Services/S360Config";
import Custom from "./Custom";

//To be done.
class CheckBox extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
        this.state       = { checked : true ,     checkedOptions : new Array(this.props.item.options.length).fill(false)}; 
    }

    handleClick(idx,lbl) {
        
        this.setState(prevState => {
            var prev = { ...prevState };
            var checkedArray = [...prev.checkedOptions];
            checkedArray [ idx ] = (checkedArray [idx] === true ? false : true);
            let checker = arr => arr.every(v => v === false);
            checkedArray[idx] ===true ? document.getElementById('ch'+(this.props.idxx+idx)).style.fontWeight = "bold" : document.getElementById('ch'+(this.props.idxx+idx)).style.fontWeight = "normal";
            checker(checkedArray) ===true ? document.getElementById(lbl).style.color = "#6c6767" : document.getElementById(lbl).style.color = "#1b145e";
            prev.checkedOptions = checkedArray;
            return { ...prev };
          });
        console.log(this.state);
    } 

    render() {
        return (
            <div className="s360-initial-form-checkbox-container" style={this.formInputBoxContainerStyle()} >
                <fieldset style={{"marginTop":"15px","marginBottom":"0px"}}>
                    <legend id={'cb'+this.props.idxx} style={{"display":"block","width":"auto","padding":"2px","marginBottom":"4px","fontSize":"12px","lineHeight":"inherit","color":"#1B145E","border":"0","borderBottom":"none","fontFamily":"poppins"}}>{this.props.item.label}</legend>
                    <div className="s360-initial-form-checkbox"  style={this.formInputBoxStyle()}>  
                                {/* {this.props && this.props.item.options && this.props.item.options.map(eachOption => { */}
                                    {/* // return <><div className="check-box-grp"><InputGroup.Checkbox aria-label="Checkbox"  onChange={(e) => { this.onCheckboxChanged(e.target.checked, eachOption); }} /> <span style={{paddingLeft:"8px", paddingRight:"20px", fontSize:"13px", color:"#000000"}}>{eachOption}</span></div></>
                                 //   return <><div className="check-box-grp"><InputGroup.Custom aria-label="Checkbox"  onChange={(e) => { this.onCheckboxChanged(e.target.checked, eachOption); }} /> <span style={{paddingLeft:"8px", paddingRight:"20px", fontSize:"13px", color:"#000000"}}>{eachOption}</span></div></>

                               // })
                            // }  */}
                            {this.props && this.props.item.options && this.props.item.options.map((eachOption,idx) => {
                                return<> 
                            <div className="s360-initial-form-checkbox-option" >
                                <Custom key={idx} checked={this.state.checkedOptions[idx] === true} onChange={this.handleClick.bind(this , idx,'cb'+this.props.idxx)} /> 
                                <span id={'ch'+(this.props.idxx + idx)}   style={{ paddingRight:"10px", fontSize:"13px", color:"#000000"}}>{eachOption}</span>
                            </div></>
                            })
                           }

                            

                    </div>
                </fieldset>
            </div>
        );
    }

//    checkedOptions = [];
//     onCheckboxChanged = (isChecked, checkBoxOption) => {
//         this.checkedOptions = this.checkedOptions.filter(i => i !== checkBoxOption);
//         if (isChecked) {
//             this.checkedOptions.push(checkBoxOption);
//         }
//     }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor:        s360ConfigService.config.designDetails.headerColor,
            backgroundColor:    s360ConfigService.config.designDetails.pageBackgroundColor,
            
        }
    }

    value = () => {
        if (this.state.checkedOptions.length === 0) { return {} ; }
        let aValue = {};
        aValue[this.props.item.label] = this.state.checkedOptions;
        return aValue;
    };

    validate = () => { 
        let formItemDetails = this.props.item || {};
        let isRequired = formItemDetails.required || formItemDetails.primaryField;
        return !(isRequired && this.state.checkedOptions.length === 0);
    }

    validationErrorMessage = () => {
        return "Please select " + this.props.item.label.toLowerCase() + ".";
    }
}


export default CheckBox;